import React from "react";
import ExpertApplicationsTabs from "@/components/admin/expert-applications/ExpertApplicationsTabs";
import EmptyApplicationsState from "@/components/admin/expert-applications/EmptyApplicationsState";
import ApplicationsGrid from "@/components/admin/expert-applications/ApplicationsGrid";
import ApplicationAnalytics from "@/components/admin/expert-applications/ApplicationAnalytics";
import { useExpertApplicationsLogic } from "@/hooks/useExpertApplicationsLogic";

export default function ExpertApplicationsContainer() {
  const {
    applications,
    publishedExperts,
    selectedApplication,
    adminNotes,
    activeTab,
    isLoading,
    setAdminNotes,
    setActiveTab,
    getFilteredApplications,
    getStatusCount,
    onStatusUpdate,
    onDeleteApplication,
    onCloseDetails,
    handleSelectApplication
  } = useExpertApplicationsLogic();

  console.log("🎨 Rendering ExpertApplicationsContainer, activeTab:", activeTab);
  console.log("📊 Total applications:", applications.length);

  const filteredApplications = getFilteredApplications();

  return (
    <>
      {/* Analytics Overview */}
      {!isLoading && (
        <ApplicationAnalytics 
          applications={applications} 
          publishedExperts={publishedExperts} 
        />
      )}

      {/* Tabs */}
      <ExpertApplicationsTabs
        activeTab={activeTab}
        onTabChange={setActiveTab}
        getStatusCount={getStatusCount}
      >
        {/* Content */}
        {isLoading ? (
          <div className="flex justify-center items-center py-8">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
              <p className="mt-2 text-sm text-muted-foreground">Loading applications...</p>
            </div>
          </div>
        ) : filteredApplications.length === 0 ? (
          <EmptyApplicationsState activeTab={activeTab} />
        ) : (
          <ApplicationsGrid
            applications={filteredApplications}
            selectedApplication={selectedApplication}
            adminNotes={adminNotes}
            onSelectApplication={handleSelectApplication}
            onSetAdminNotes={setAdminNotes}
            onStatusUpdate={onStatusUpdate}
            onDelete={onDeleteApplication}
            onClose={onCloseDetails}
          />
        )}
      </ExpertApplicationsTabs>
    </>
  );
}